export var FeatureFlagPrefix;
(function (FeatureFlagPrefix) {
    FeatureFlagPrefix["QueryParam"] = "qp:";
    FeatureFlagPrefix["FeaturesApi"] = "gbi:";
})(FeatureFlagPrefix || (FeatureFlagPrefix = {}));
export var FeatureFlag;
(function (FeatureFlag) {
    FeatureFlag["ConfigTypeNavigation"] = "enableConfigTypeNavigation";
    FeatureFlag["EmojiLang"] = "enableEmojiLang";
    FeatureFlag["UnverifiedTranslations"] = "enableUnverifiedTranslations";
    FeatureFlag["SingleTenantEnabled"] = "enableSingleTenant";
    FeatureFlag["SingleTenantName"] = "singleTenantName";
    FeatureFlag["EnableHighlightMostRecentlyCreatedModel"] = "enableHighlightMostRecentlyCreated";
    FeatureFlag["EnablePipelineHealth"] = "enablePipelineHealth";
    FeatureFlag["EnableAttributeFiltering"] = "enableAttributeFiltering";
    FeatureFlag["enableFontSize"] = "enableFontSize";
    FeatureFlag["enableEvaluationToolDebug"] = "enableEvaluationToolDebug";
    // TODO: Clean it up after 'tileShowAttributesEnabled' feature flag will be irrelevant
    FeatureFlag["EnableTileShowAttributes"] = "enableTileShowAttributes";
    FeatureFlag["EnableNewSearchPerformanceDashboard"] = "enableNewSearchPerformanceDashboard";
    FeatureFlag["enablePartNumberMongoAutocomplete"] = "enablePartNumberMongoAutocomplete";
    FeatureFlag["enableMongoPartNumberSearch"] = "enableMongoPartNumberSearch";
    FeatureFlag["enableDashboardModules"] = "enableDashboardModules";
    FeatureFlag["enableNewHomePageLayout"] = "enableNewHomePageLayout";
    FeatureFlag["enableGeographyModule"] = "enableGeographyModule";
    FeatureFlag["enableSeoStudio"] = "enableSeoStudio";
    FeatureFlag["enablePillExtendedWidth"] = "enablePillExtendedWidth";
    FeatureFlag["enableBrainSuiteBranding"] = "enableBrainSuiteBranding";
    FeatureFlag["Next"] = "enableNext";
    FeatureFlag["enableBulkAddKeywords"] = "enableBulkAddKeywords";
    FeatureFlag["EnableBeaconValidationDashboard"] = "enableBeaconValidationDashboard";
    // --- Rules Feature Flags ---
    // See https://rezolvetech.atlassian.net/wiki/x/EgCtQgE
    FeatureFlag["EnableShowFacetTab"] = "enableShowFacetTab";
    FeatureFlag["EnableRecallSearchFiltering"] = "enableRecallSearchFiltering";
    FeatureFlag["enableRuleProductVisibilityBias"] = "enableRuleProductVisibilityBias";
    FeatureFlag["EnableBuildFacetV2"] = "enableBuildFacetV2";
})(FeatureFlag || (FeatureFlag = {}));
